<section>
  <div flex fxLayout="column" fxLayoutAlign="center">
    <strong>Empfänger</strong>
    <p style="font-size: 0.8rem; margin-bottom: 0.5rem">
      {{ this.data.actionInfo.recipients }}
    </p>
    <strong>Betreff der E-Mail</strong>
    <p style="font-size: 0.8rem; margin-bottom: 0.5rem">
      {{ this.data.actionInfo.subject }}
    </p>
    <div *ngIf="currentForm">
      <form [formGroup]="currentForm">
        <form-row>
          <mat-form-field appearance="outline" name="feedInManagementSerialNumber" fxFlex>
            <mat-label>Seriennummer des Einspeisermanagements</mat-label>
            <input matInput type="text" formControlName="feedInManagementSerialNumber" />
          </mat-form-field>
        </form-row>
      </form>
    </div>
  </div>
  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
    <button mat-raised-button color="primary" id="modal-confirm-button" (click)="confirm()">Speichern</button>
  </div>
</section>
